import React from "react";
import ReactDOM from 'react-dom';
import WhatToDo from "./components/WhatToDo";

export default () => {

    const doms = document.querySelectorAll('[data-what-to-do]');
    for (const dom of doms) {
        const json = JSON.parse(dom.getAttribute('data-what-to-do'));
        const prefix = dom.getAttribute('data-listing-page');
        ReactDOM.render(<WhatToDo data={json} prefix={prefix} />, dom);
    }

}
